import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import GenericPaymentMethod from './GenericPaymentMethod';
import OneyIcon from 'components/Common/Icons/Oney/Oney';
import FormikTextRow from 'components/Common/Formik/Row/FormikTextRow';
import TelephoneRowComponent from 'components/Common/Formik/Row/RowComponent/TelephoneRowComponent';
import { useCustomer } from 'hooks/useCustomer';
import useOneyWidget from 'hooks/useOneyWidget/useOneyWidget';
import PaymentMethod from 'model/PaymentMethod';
import { AC } from 'settings/form';
import { FIELDS_REGEX } from 'settings/regex';
import { MethodProps } from 'types/PaymentFormType';

import styles from './PaymentMethod.module.scss';

export default function OneyPaymentMethod({
  setPaymentMethod,
  isSelected,
  cart,
}: MethodProps): JSX.Element {
  const { t } = useTranslation(['checkout']);
  const { customer } = useCustomer();
  const { showOneyWidgetCheckout } = useOneyWidget();

  useEffect(() => {
    if (isSelected) {
      showOneyWidgetCheckout({
        paymentAmount: cart.totalPrice,
        placeholderId: '#oney-checkout-placeholder',
      });
    }
  }, [isSelected]);

  return (
    <GenericPaymentMethod
      value={PaymentMethod.oney}
      classes={{ methodTitle: styles.oneyMethodTitle }}
      onClick={() => {
        void setPaymentMethod(PaymentMethod.oney);
      }}
      labelContent={
        <>
          <span className={styles.methodLogo}>
            <OneyIcon className={styles.oneyIcon} />
          </span>
          <span>{t('ONEY_METHOD_TITLE')}</span>
        </>
      }
    >
      {isSelected && (
        <div className={styles.oneyMethodContentContainer}>
          {!customer?.cellPhone && (
            <div className={styles.cellPhoneInformationContainer}>
              <p className={styles.cellPhoneInformation}>
                {t('ONEY_CELL_PHONE_REQUIRED_INFO')}
              </p>
              <FormikTextRow
                label={t('INPUT_PHONE_NUMBER')}
                component={TelephoneRowComponent}
                aroundOnChange={(onChange, event) => {
                  const el = event.target as HTMLInputElement;

                  if (FIELDS_REGEX['number'].test(el.value)) {
                    onChange(event);
                  }
                }}
                inputProps={{
                  required: true,
                  name: 'cellPhone',
                  autoComplete: AC.Off,
                  placeholder: t('INPUT_PHONE_NUMBER_PLACEHOLDER'),
                }}
              />
            </div>
          )}
          <div
            className={styles.oneyPlaceholder}
            id="oney-checkout-placeholder"
          />
        </div>
      )}
    </GenericPaymentMethod>
  );
}
